import { z } from 'zod';
/** Double-submit CSRF token: readable cookie whose value must be echoed in {@link CSRF_HEADER}. */
export const CSRF_COOKIE_NAME = 'mfos_csrf';
export const CSRF_HEADER = 'x-csrf-token';
export const csrfTokenResponseSchema = z.object({ csrfToken: z.string().min(16) });
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 100;
/** Cursor pagination for growing feeds (audit log, ledgers). `nextCursor` is opaque. */
export function cursorPageSchema(item) {
    return z.object({ items: z.array(item), nextCursor: z.string().nullable() });
}
export const pageQuerySchema = z.object({
    cursor: z.string().min(1).max(200).optional(),
    limit: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});
//# sourceMappingURL=http.js.map